import styled from 'styled-components';

const Wrapper = styled.div `
  color: #0b1f1c;
  font-family: ${props => props.theme.fontFamilies.main.regular};
  width: 100%;
  gap: 24px;
  display: flex;
  flex-direction: column;
  background-color: #f7fafa;
  padding: 40px 24px;
`;
const HeaderContainer = styled.div `
  display: flex;
  justify-content: flex-start;
`;
const IconContainer = styled.div `
  margin-right: 10px;
`;
const Body = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const IndividualContainer = styled.div `
  padding: 24px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
`;
const QuestionBody = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
const FaqControlIcon = styled.div `
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid rgba(11, 31, 28, 0.16);
  cursor: pointer;
  &:hover {
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
  }
`;

export { Body, FaqControlIcon, HeaderContainer, IconContainer, IndividualContainer, QuestionBody, Wrapper };
